import AuthorizedCredit from '@/generated/classes/AuthorizedCredit';
export default class AuthorizedCreditExtend extends AuthorizedCredit {
  constructor() {
    super();
  }
}
